import PropTypes from 'prop-types';
import React from 'react';
// import ReactModal from 'react-modal';
import Draggable from 'react-draggable'
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import bluetooth from './bluetooth.svg'
import styles from './modal.css';
import {
    updateHandpyMobileBtnModalSwitch,
    updateHandpyMobileMsgModalSwitch,
    closeHandpyMobileBtnModal,
    closeHandpyMobileMsgModal,
    updateHandpyMobileBtnModalBle,
    updateHandpyMobileMsgModalBle,
    updateHandpyMobileMsg
} from '../../reducers/modals';

class ModalComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'closeModal',
            'handleModalSizeChange',
            'handleChangeBtnStatus',
            'handleBleNameClick',
            'handleBtnClick',
            'handleScrollHeightChange'
        ]);
        this.state = {
            isLarge: false,
            scrollHeight: 0,
        };
    }
    // 数据处理
    componentWillReceiveProps (nextProps) {
        this.handleScrollHeightChange();
    }

    onStart (e) {
    };
    handleDrag (e) {
    };
    onStop () {
    };

    // 缩放功能
    handleModalSizeChange () {
        this.setState({
            isLarge: !this.state.isLarge
        })
    }
    closeModal () {
        if (this.props.mobileFor == 'btnModal') {
            this.props.closeHandpyMobileBtnModal();
        }
        if (this.props.mobileFor == 'msgModal') {
            this.props.closeHandpyMobileMsgModal();
        }
    }
    handleChangeBtnStatus () {
        if (this.props.mobileFor == 'btnModal') {
            this.props.updateHandpyMobileBtnModalSwitch(!this.props.handpyMobileBtnModalSwitch);
        }
        if (this.props.mobileFor == 'msgModal') {
            this.props.updateHandpyMobileMsgModalSwitch(!this.props.handpyMobileMsgModalSwitch);
        }

    }
    handleBleNameClick () {
        // alert(this.props.handpyMobileModalBleName)
        if (this.props.mobileFor == 'btnModal') {
            // handpyMobileBtnModalBle
            this.props.updateHandpyMobileBtnModalBle(true);
        }
        if (this.props.mobileFor == 'msgModal') {
            // handpyMobileMsgModalBle
            this.props.updateHandpyMobileMsgModalBle(true);
        }
    }
    handleBtnClick (str) {
        this.props.updateHandpyMobileMsg(str)
        // this.props.updateHandpyMobileMsg('')
    }

    handleScrollHeightChange () {
        // console.log('this.resizeBox ? ', this.resizeBox)
        if (!this.resizeBox) {
            return false;
        }
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            const {scrollHeight, clientHeight} = this.resizeBox;
            if (scrollHeight != this.state.scrollHeight) {
                this.setState({scrollHeight});
                this.resizeBox.scrollTop = scrollHeight - clientHeight;
            }
            this.timer = null;
        }, 300);
    }

    handleStart () { }
    handleStop () { }
    render () {
        // this.props.mobileFor --> btnModal msgModal
        // console.log(this.props)
        
        const { 
            mobileFor,
            handpyMobileBtnModalSwitch,
            handpyMobileBtnModalBle,
            handpyMobileMsgModalSwitch,
            handpyMobileMsgModalBle,
            handpyMobileModalBleName,
            handpyMobileModalBleMsg
        } = this.props;
        let mobileTitle = '',
            switchStatus = false,
            bleStatus = false

        if (mobileFor === 'btnModal') {
            mobileTitle = '远程指令APP';
            switchStatus = handpyMobileBtnModalSwitch;
            bleStatus = handpyMobileBtnModalBle;
        }
        if (mobileFor === 'msgModal') {
            mobileTitle = '接收数据APP';
            switchStatus = handpyMobileMsgModalSwitch;
            bleStatus = handpyMobileMsgModalBle;
        }

        return (
            <div className="draggable_box">
                <Draggable
                    onStart={this.handleStart}
                    onDrag={this.handleDrag}
                    onStop={this.handleStop}
                >
                    <div className={styles.modalChart} >
                        <span
                            className={styles.closeModal}
                            onClick={this.closeModal}
                        >×</span>
                        <p className={styles.boardMobileTitle}>{mobileTitle}</p>
                        <div className={styles.boardMobile} >
                            <div className={styles.boardMobileOutline} >
                                <span className={styles.boardMobileEar}></span>
                                <div className={styles.boardMobileInline} >
                                    <div className={styles.boardMobileBar}>
                                        {!bleStatus && (<div className={styles.boardMobileBarBtnGroup}>
                                            蓝牙
                                            <span
                                                className={styles.boardMobileBarSwitch + (switchStatus ? (' '+ styles.active) : '')}
                                                onClick={this.handleChangeBtnStatus}
                                            />
                                        </div>)}
                                        {bleStatus && (<div className={styles.boardMobileBarText}>连接成功...</div>)}
                                    </div>

                                    {(switchStatus && !bleStatus) && (<div className={styles.bleList}>
                                        <p className={styles.boardMobileBleListTitle}>可用设备</p>
                                        {
                                            handpyMobileModalBleName
                                            && 
                                            <p 
                                                className={styles.boardMobileBleListItem}
                                                onClick={this.handleBleNameClick}
                                            >
                                                <img
                                                    src={bluetooth}
                                                    alt="bluetooth"
                                                />
                                                {handpyMobileModalBleName}
                                            </p>
                                        }
                                        {/* <p className={styles.boardMobileBleListItem}>
                                            <img
                                                src={bluetooth}
                                                alt="bluetooth"
                                            />
                                            Unkown Devices
                                        </p>
                                        <p className={styles.boardMobileBleListItem}>
                                            <img
                                                src={bluetooth}
                                                alt="bluetooth"
                                            />
                                            Unkown Devices
                                        </p> */}
                                    </div>)}
                                    {(bleStatus && mobileFor === 'btnModal') && (
                                        <div className={styles.boardMobileContainer}>
                                            <p className={styles.boardMobileContainerBtnGroupTitle}>请选择指令</p>
                                            <div className={styles.boardMobileContainerBtnGroup}>
                                                <span
                                                    className={styles.boardMobileContainerBtn}
                                                    onMouseDown={this.handleBtnClick.bind(this, '该吃药了')}
                                                    onTouchStart={this.handleBtnClick.bind(this, '该吃药了')}
                                                    onMouseUp={this.handleBtnClick.bind(this, '')}
                                                    onTouchCancel={this.handleBtnClick.bind(this, '')}
                                                >该吃药了</span>
                                                <span
                                                    className={styles.boardMobileContainerBtn}
                                                    onMouseDown={this.handleBtnClick.bind(this, '该回家了')}
                                                    onTouchStart={this.handleBtnClick.bind(this, '该回家了')}
                                                    onMouseUp={this.handleBtnClick.bind(this, '')}
                                                    onTouchCancel={this.handleBtnClick.bind(this, '')}
                                                >该回家了</span>
                                            </div>
                                        </div>
                                    )}
                                    {(bleStatus && mobileFor === 'msgModal') && (
                                        <div className={styles.boardMobileContainer}>
                                            <table
                                                className={styles.chart_table}
                                                border="1px"
                                            >
                                                <tbody
                                                    className={styles.table_body}
                                                    style={{height: '380px'}}
                                                    ref={el => this.resizeBox = el}
                                                >
                                                    {handpyMobileModalBleMsg && handpyMobileModalBleMsg.map((v, i) => {
                                                        return <tr key={i}>
                                                            <td style={{width: '40%'}}>{new Date(v.timestamp).Format('hh:mm:ss')} 接收 </td>
                                                            <td style={{width: '60%'}}>{v.message}</td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                <span className={styles.boardMobileButton}></span>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        );
    }
}


ModalComponent.propTypes = {
    updateHandpyMobileBtnModalSwitch: PropTypes.func,
    updateHandpyMobileMsgModalSwitch: PropTypes.func,
    // tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
    // title: PropTypes.string.isRequired
    mobileFor: PropTypes.string,
    handpyMobileBtnModalSwitch: PropTypes.bool,
    handpyMobileMsgModalSwitch: PropTypes.bool,
    closeHandpyMobileBtnModal: PropTypes.func,
    closeHandpyMobileMsgModal: PropTypes.func,
    handpyMobileModalBleName: PropTypes.string,
    updateHandpyMobileBtnModalBle: PropTypes.func,
    updateHandpyMobileMsgModalBle: PropTypes.func,
    handpyMobileBtnModalBle: PropTypes.bool,
    handpyMobileMsgModalBle: PropTypes.bool,
    updateHandpyMobileMsg: PropTypes.func,
    handpyMobileModalBleMsg: PropTypes.array
}
const mapStateToProps = state => ({
    handpyMobileBtnModalSwitch: state.scratchGui.modals.HANDPY_MOBILE_BTN_MODAL_SWITCH,
    handpyMobileMsgModalSwitch: state.scratchGui.modals.HANDPY_MOBILE_MSG_MODAL_SWITCH,
    handpyMobileModalBleName: state.scratchGui.modals.HANDPY_MOBILE_MODAL_BLE_NAME,
    handpyMobileBtnModalBle: state.scratchGui.modals.HANDPY_MOBILE_BTN_MODAL_BLE,
    handpyMobileMsgModalBle: state.scratchGui.modals.HANDPY_MOBILE_MSG_MODAL_BLE,
    handpyMobileModalBleMsg: state.scratchGui.modals.HANDPY_MOBILE_MODAL_BLE_MSG
});

const mapDispatchToProps = dispatch => ({
    updateHandpyMobileBtnModalSwitch: data => dispatch(updateHandpyMobileBtnModalSwitch(data)),
    updateHandpyMobileMsgModalSwitch: data => dispatch(updateHandpyMobileMsgModalSwitch(data)),
    closeHandpyMobileBtnModal: data => dispatch(closeHandpyMobileBtnModal(data)),
    closeHandpyMobileMsgModal: data => dispatch(closeHandpyMobileMsgModal(data)),
    updateHandpyMobileBtnModalBle: data => dispatch(updateHandpyMobileBtnModalBle(data)),
    updateHandpyMobileMsgModalBle: data => dispatch(updateHandpyMobileMsgModalBle(data)),
    updateHandpyMobileMsg: data => dispatch(updateHandpyMobileMsg(data))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalComponent);

